import React, { useEffect, useState } from 'react';
import {
    formatCurrency,
    getAlert,
    getDataWithComp,
    parseCurrency,
    useEscapeClose
} from '../../../utils/SamuiUtils';
import { formatDate } from '../../../utils/DateUtils';

function CustomerUnpaidModal({ isOpen, onClose, arId, arName }) {
    const [saleOrders, setSaleOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    useEscapeClose(isOpen, onClose);

    useEffect(() => {
        const fetchSaleOrders = async () => {
            if (!isOpen || !arId) {
                setSaleOrders([]);
                return;
            }

            setLoading(true);
            try {
                const response = await getDataWithComp(
                    'API_0701_SO_H',
                    `AND Doc_Status <> 13 AND Doc_Status_Paid = 2 AND AR_Id = ${arId} ORDER BY CONVERT(date, Doc_Date) DESC, Doc_No DESC`
                );
                setSaleOrders(response || []);
            } catch (error) {
                getAlert('FAILED', 'ไม่สามารถโหลดใบขายค้างชำระได้');
                setSaleOrders([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSaleOrders();
    }, [isOpen, arId]);

    if (!isOpen) {
        return null;
    }

    const toNumber = (value) => {
        const parsed = parseCurrency(value ?? 0);
        return typeof parsed === 'number' && !isNaN(parsed) ? parsed : Number(parsed) || 0;
    };

    return (
        <>
            <div
                className={`modal ${isOpen ? 'show' : ''}`}
                style={{ display: isOpen ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">ใบขายค้างชำระ ของ {arName || '-'}</h5>
                            <button type="button" className="close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center">เลขที่เอกสาร</th>
                                            <th className="text-center">วันที่เอกสาร</th>
                                            <th className="text-center">ยอดรวม</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={3}>
                                                    <center>
                                                        <h6>กำลังโหลดข้อมูล...</h6>
                                                    </center>
                                                </td>
                                            </tr>
                                        ) : saleOrders.length > 0 ? (
                                            saleOrders.map((order) => {
                                                const netTotal = toNumber(order?.NetTotal ?? order?.Net_Total ?? 0);
                                                return (
                                                    <tr key={order?.Doc_ID || order?.Doc_No}>
                                                        <td className="text-center">{order?.Doc_No || '-'}</td>
                                                        <td className="text-center">{formatDate(order?.Doc_Date) || '-'}</td>
                                                        <td className="text-end">{formatCurrency(netTotal)}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={3}>
                                                    <center>
                                                        <h6>ไม่พบข้อมูล</h6>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning text-white" onClick={onClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default CustomerUnpaidModal;
